// removed by extract-text-webpack-plugin
module.exports = {"container":"_26Glm _7mR3c","storesList":"_1SOk_","header":"_1p680","subheader":"_3QDCh"};


//////////////////
// WEBPACK FOOTER
// ./banquet/containers/MarketingStoresListContainer/index.sass
// module id = 1525
// module chunks = 1